import { render } from "./Configurator3d.vue?vue&type=template&id=278fd912&scoped=true"
import script from "./Configurator3d.vue?vue&type=script&lang=js"
export * from "./Configurator3d.vue?vue&type=script&lang=js"

import "./Configurator3d.vue?vue&type=style&index=0&id=278fd912&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278fd912"]])

export default __exports__